import { render, staticRenderFns } from "./Detailv2.vue?vue&type=template&id=349ad350&"
import script from "./Detailv2.vue?vue&type=script&lang=js&"
export * from "./Detailv2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports